// commonClass 共通処理用Class

export default class commonClass {
  // コンストラクタ
  constructor() {
    // this._BREAKPOINT = 768;
  }

  // 値を返却
  _getter(key) {
    return this[key];
  }

  // 値を設定
  _setter(key, val) {
    this[key] = val;
  }

  // デバッグ用関数
  _log(str='', val) {
    console.log(str + ': ' + val);
  }

  // エスケープ用関数
  // @param {id/class} arg: 要素の値
  // return string エスケープした文字列
  _htmlEscape(arg) {
    if (!arg) return;
    return arg.replace(/[<>&"'`]/g, function(match) {
      const escape = {
        '<': '&lt;',
        '>': '&gt;',
        '&': '&amp;',
        '"': '&quot;',
        "'": '&#39;',
        '`': '&#x60;'
      };
      return escape[match];
    });
  }

  // ユニークな文字列を生成
  _getUniqueString() {
    return new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16);
  }
}